module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.432/css/toolsmenu.css"